import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class ResultService {
  private translocoService = inject(TranslocoService);
  constructor(private snackBar: MatSnackBar) { }

  showMessage(message: string | null = null): void {
    if (!message) return;
    this.snackBar.open(message, this.translocoService.translate('Close'),
      { duration: 2000, horizontalPosition: 'end', verticalPosition: 'bottom' });
  }

  showSuccess(message: string | null = null): void {
    if (!message) return;
    this.snackBar.open(message, this.translocoService.translate('Close'), {
      duration: 2000,
      panelClass: ['snack-success'],
      horizontalPosition: 'end',
      verticalPosition: 'bottom'
    });
  }

  showError(error: any = null): void {
    if (!error) {
      return;
    }

    if (error && error.status === 401) {
      return;
    }

    if (error && error.status === 403) {
      return;
    }

    const message = this.extractMessage(error);
    if (!message) return;
    this.snackBar.open(message, this.translocoService.translate('Close'), {
      duration: 6000,
      panelClass: ['snack-error'],
      horizontalPosition: 'end',
      verticalPosition: 'bottom'
    });
  }

  private extractMessage(error: any): string | null {
    if (!error) return null;
    if (typeof error === 'string') return error || null;

    // HttpErrorResponse
    if (error?.name === 'HttpErrorResponse') {
      if (error.status === 0) return this.translocoService.translate('No server connection.');
      const msgs: { text: string }[] | undefined = error.error?.messages;
      if (msgs?.length) return msgs.map(m => m.text).join('\n');
      return error.error?.message ?? error.message ?? `${this.translocoService.translate('Error')} ${error.status}`;
    }

    return error?.message ?? String(error) ?? null;
  }
}


